
const Knowledges = (props) => {
    const knowledges = props.knowledges
    // console.log(knowledges);

    const datamap = knowledges?.map((item, index) => {
        return <li key={item.id}>{item.name}</li>
    })

    return (
        <div className="knowledges">
            <ul>
                {datamap}
            </ul>
        </div>
    )
}
export default Knowledges;